import { render, staticRenderFns } from "./HighlightsForm.vue?vue&type=template&id=9f4a530e&"
import script from "./HighlightsForm.vue?vue&type=script&lang=js&"
export * from "./HighlightsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports